import {
  Component,
  forwardRef,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

let nextId = 0;

@Component({
  selector: 'app-terms-checkbox',
  standalone: false,
  templateUrl: './terms-checkbox.component.html',
  styleUrl: './terms-checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TermsCheckboxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TermsCheckboxComponent),
      multi: true,
    },
  ],
})
export class TermsCheckboxComponent implements ControlValueAccessor, Validator {
  @ViewChild('template') templateRef!: TemplateRef<unknown>;

  inputId = `termsAccepted-${nextId++}`;
  checked = false;
  disabled = false;
  modalRef?: BsModalRef;
  canUnderstand = false;

  private onChange: (value: boolean) => void = () => {};
  onTouched: () => void = () => {};

  constructor(private modal: BsModalService) {}

  writeValue(value: boolean): void {
    this.checked = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.checked ? null : { required: true };
  }

  onCheckboxClick(event: Event): void {
    event.preventDefault();
    this.openTerms();
  }

  openTerms(): void {
    this.canUnderstand = false;
    this.modalRef = this.modal.show(this.templateRef, {
      class: 'modal-lg modal-dialog modal-dialog-scrollable',
    });
  }

  onTermsScroll(event: Event): void {
    if (this.canUnderstand) {
      return;
    }
    const el = event.target as HTMLElement;
    const scrolledToBottom =
      el.scrollHeight - el.scrollTop - el.clientHeight < 20;
    if (scrolledToBottom) {
      this.canUnderstand = true;
    }
  }

  understandTerms(): void {
    if (!this.canUnderstand) {
      return;
    }
    this.modalRef?.hide();
    this.checked = true;
    this.onChange(true);
    this.onTouched();
  }
}
